import type { FC } from 'react';

import type { TextFieldBaseProps } from './types';

export const TextFieldMessage: FC<Pick<TextFieldBaseProps, 'isInvalid'> & { id?: string }> = ({
  isInvalid,
  id,
}) => {
  if (typeof isInvalid !== 'string' || !isInvalid) return null;
  return (
    <p id={id} className='fig-field-error'>
      {isInvalid}
    </p>
  );
};
